import ButtonKingdee from './src/main'

ButtonKingdee.install = function (Vue) {
    Vue.component(ButtonKingdee.name, ButtonKingdee)
}

export default ButtonKingdee